import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[commonSelectSingleRow]",
  standalone: true,
})
export class SelectSingleRowDirective {
  constructor(private el: ElementRef) {}

  @HostListener("click", ["$event"])
  onCheckboxClicked(event: MouseEvent): void {
    const cbxElement = event.target as HTMLInputElement;
    if (cbxElement.checked) {
      this.el.nativeElement.closest("tr").classList.add("selected");
    } else {
      this.el.nativeElement.closest("tr").classList.remove("selected");
    }
    event.stopPropagation();
  }
}
